// @flow

import { ACTIONS } from './constants';

export const setFeatures = (features: {}) => (dispatch: Function) => {
    dispatch({
        type: ACTIONS.FEATURES_SET,
        features
    });
};



// WEBPACK FOOTER //
// ./src/v5/features/state/setFeatures.js